module.exports = __webpack_public_path__ + "img/user-national-emblem-pic.929bfcaa.png";